













import { Vue, Component } from 'vue-property-decorator'

@Component({
  props: ['isHidden'],
})
export default class LittleEllipsis extends Vue {}
